import CreateTribunalCase from './CreateTribunalCase.js';
export default CreateTribunalCase;
//# sourceMappingURL=index.js.map